import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95fa2c34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-between items-center q-pa-sm" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "col text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-h6" }, "My Keeps")
], -1))
const _hoisted_3 = { class: "col-5" }
const _hoisted_4 = { class: "col text-right" }
const _hoisted_5 = {
  key: 0,
  class: "column q-my-xl content-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row text-h6" }, " You have no saved items. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row caption justify-center" }, " Get started by creating your first item. ", -1))

import { computed, onMounted, ref } from "vue";
import ItemDialog from "@/modules/item/components/ItemDialog.vue"
import FilterInput from "@/components/FilterInput.vue";
import Tag from "@/modules/tag/model/Tag";
import TagView from "@/modules/tag/components/Tag.vue";

import ItemView from "@/modules/item/components/Item";

import { container } from "@/system/container";
import { TOKENS } from "@/system/tokens";
import { useItemStore } from "@/modules/item/model/ItemService";
import { Item } from "@/modules/item/model/Item";


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemsPage',
  setup(__props) {

const factory = container.get(TOKENS.itemFactory);
const showDialog = ref(false);
const item = ref();
const itemStore = useItemStore();
const selectedTags = ref<Tag[]>([]);



const openDialogForNewItem = () => {
  item.value = factory.createDefaultUnsavedItem();
  showDialog.value = true;
};

const items = computed<Item[]>(() => itemStore.filterOnTags(selectedTags.value).value)

const edit = (_item: Item) => {
  item.value = _item;
  showDialog.value = true;
};

const selectTag = (tag: Tag) => {
  if (selectedTags.value.findIndex(t => t.id === tag.id) > -1) 
    return
    
  selectedTags.value?.push(tag);
};

const unselectTag = (tag: Tag) => {
  const index = selectedTags.value.findIndex((t) => t.id === tag.id)
  if (index > -1) {
    selectedTags.value.splice(index, 1)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _createVNode(FilterInput, {
          modelValue: selectedTags.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTags).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_q_btn, {
          round: "",
          color: "green-5",
          icon: "add",
          onClick: openDialogForNewItem
        })
      ]),
      _createVNode(ItemDialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event)),
        item: item.value
      }, null, 8, ["modelValue", "item"])
    ]),
    _createVNode(_component_q_separator, { class: "q-my-md" }),
    _createVNode(_component_q_list, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
          return (_openBlock(), _createBlock(_unref(ItemView), {
            key: item.id,
            item: item,
            onEdit: edit,
            onSelect: selectTag
          }, null, 8, ["item"]))
        }), 128))
      ]),
      _: 1
    }),
    (!_unref(items))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("span", {
            onClick: openDialogForNewItem,
            class: "q-my-sm create-link-text"
          }, " + Create Item ")
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})